/* eslint-disable no-nested-ternary */
import React, { FC, ReactNode } from 'react';
import Link from 'next/link';
import { styled } from 'linaria/react';
import { useAuthDataStore, UserAvatarButtonWithMenu } from '@entities/user';
import { withTheme } from '@shared/lib/theme';
import { BrowserType, useBrowser, useWindowScrollPosition } from '@shared/lib/browser';
import { Partners, usePartner } from '@shared/lib/partner';
import { Desktop, Mobile } from '@shared/lib/react';
import { NoSSR, useCurrentTspOnly, useElementRectById, useElementTrigger } from '@shared/lib';
import Logo from './logo/Logo';
import LoginButton from './LoginButton';
import UserAvatarMenu from './UserAvatarMenu';
interface HeaderProps {
  widget?: ReactNode;
  navbar: ReactNode;
  searchButton: ReactNode;
  mobileSearchButton?: ReactNode;
}
const Header: FC<HeaderProps> = ({
  widget,
  navbar,
  searchButton,
  mobileSearchButton
}) => {
  const {
    isAuth
  } = useAuthDataStore();
  const {
    partner
  } = usePartner();
  const {
    isCurrentTspOnly
  } = useCurrentTspOnly();
  const isAtTop = useWindowScrollPosition();
  const isActive = useElementTrigger('search-input-with-wrapper', 65 + 8);
  const headerRect = useElementRectById('header');
  const isHeaderCollapsedWithCategoryPicker = useElementTrigger('category-picker', headerRect?.height, true);
  const browser = useBrowser();
  const isSafari = browser === BrowserType.SAFARI;
  return <HeaderWrapper id="header" isSafari={isSafari} isActive={isActive} isAtTop={isAtTop} isHeaderCollapsedWithCategoryPicker={isHeaderCollapsedWithCategoryPicker}>
      <TopSection>
        {isCurrentTspOnly ? <LogoWrapper>
            <NoSSR>
              <Logo />
            </NoSSR>
          </LogoWrapper> : <LogoLink href="/">
            <LogoWrapper>
              <NoSSR>
                <Logo />
              </NoSSR>
            </LogoWrapper>
          </LogoLink>}
        <Desktop>
          <WidgetWrapper isAtTop={isAtTop}>{widget}</WidgetWrapper>
          {!isCurrentTspOnly && <NavbarWrapper isAtTop={isAtTop}>{navbar}</NavbarWrapper>}
        </Desktop>
        <ActionsWrapper>
          {!isCurrentTspOnly && <Mobile>{mobileSearchButton}</Mobile>}
          {partner === Partners.DEFAULT && <NoSSR>
              {isAuth ? <UserAvatarButtonWithMenu menu={({
            open,
            onClose
          }) => <UserAvatarMenu open={open} onClose={onClose} />} /> : <LoginButton />}
            </NoSSR>}
        </ActionsWrapper>
      </TopSection>
      <Mobile>{isActive && <BottomSection>{searchButton}</BottomSection>}</Mobile>
    </HeaderWrapper>;
};
export default Header;
interface HeaderWrapperProps {
  isAtTop: boolean;
  isActive: boolean;
  isSafari: boolean;
  isHeaderCollapsedWithCategoryPicker: boolean;
}
const _exp = /*#__PURE__*/() => ({
  isAtTop,
  isHeaderCollapsedWithCategoryPicker,
  theme
}) => isAtTop ? 'transparent' : isHeaderCollapsedWithCategoryPicker ? theme.colors.background.primary : theme.colors.background.header;
const _exp2 = /*#__PURE__*/() => ({
  isAtTop
}) => isAtTop ? 'none' : 'blur(1rem)';
const _exp3 = /*#__PURE__*/() => ({
  isAtTop
}) => isAtTop ? 'none' : 'blur(60px)';
const _exp4 = /*#__PURE__*/() => ({
  isSafari,
  isActive
}) => isSafari && isActive ? '-55px' : '0';
const HeaderWrapper = withTheme(/*#__PURE__*/styled('header')({
  name: "HeaderWrapper",
  class: "hsv7cxi",
  propsAsIs: false,
  vars: {
    "hsv7cxi-0": [_exp()],
    "hsv7cxi-1": [_exp2()],
    "hsv7cxi-2": [_exp3()],
    "hsv7cxi-3": [_exp4()]
  }
}));
const TopSection = /*#__PURE__*/styled('div')({
  name: "TopSection",
  class: "t104tzhm",
  propsAsIs: false
});
const _exp5 = /*#__PURE__*/() => Link;
const LogoLink = /*#__PURE__*/styled(_exp5())({
  name: "LogoLink",
  class: "l1aw4bh1",
  propsAsIs: true
});
const LogoWrapper = /*#__PURE__*/styled('div')({
  name: "LogoWrapper",
  class: "lv9viuu",
  propsAsIs: false
});
const ActionsWrapper = /*#__PURE__*/styled('div')({
  name: "ActionsWrapper",
  class: "awib43l",
  propsAsIs: false
});
const BottomSection = /*#__PURE__*/styled('div')({
  name: "BottomSection",
  class: "brnxsr0",
  propsAsIs: false
});
interface WidgetWrapperProps {
  isAtTop: boolean;
}
const _exp6 = /*#__PURE__*/() => ({
  isAtTop
}) => isAtTop ? 'translate(-50%, -50%) scale(1)' : 'translate(-50%, -100%) scale(0)';
const WidgetWrapper = /*#__PURE__*/styled('div')({
  name: "WidgetWrapper",
  class: "wyxcitl",
  propsAsIs: false,
  vars: {
    "wyxcitl-0": [_exp6()]
  }
});
interface NavbarWrapperProps {
  isAtTop: boolean;
}
const _exp7 = /*#__PURE__*/() => ({
  isAtTop
}) => isAtTop ? '100%' : '50%';
const _exp8 = /*#__PURE__*/() => ({
  isAtTop
}) => isAtTop ? 'translate(-50%, 0)' : 'translate(-50%, -50%)';
const NavbarWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "NavbarWrapper",
  class: "nve63wq",
  propsAsIs: false,
  vars: {
    "nve63wq-0": [_exp7()],
    "nve63wq-1": [_exp8()]
  }
}));

require("./Header.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./Header.tsx");